module.exports = __webpack_public_path__ + "static/media/ils_digilocker_failed.d82ed696.svg";